const LocalService = {
    HISTORIC_FAV_KEY: "LKHISTORICFAV",   
    PIN_FAV_KEY: "LKPINFAV",
    LATEST_FAV_KEY: "LKLATESTFAV",
    // FAV_DATE: "LKFAVDATESELECTION",
    // LATESTDATA_FAV_KEY: "LKLATESTDATAFAV",
    FAV_SETTINGS: "LKFAVSETTINGS",

    isFav: (station, component) => {
        const s = localStorage.getItem(LocalService.LATEST_FAV_KEY + station + component);
        return s ? true : false;
    },
    setFav: (station, component) => {
        localStorage.setItem(LocalService.LATEST_FAV_KEY + station + component, "fav");
    },
    removeFav: (station, component) => {
        localStorage.removeItem(LocalService.LATEST_FAV_KEY + station + component);
    },
    toggleFav: (station, component) => {
        const isFav = LocalService.isFav(station, component);
        if (isFav)
            LocalService.removeFav(station, component);
        else
            LocalService.setFav(station, component);

        return !isFav;
    },

    getAllHistoricFavs: () => {
        const fav = localStorage.getItem(LocalService.HISTORIC_FAV_KEY);
        if (!fav) return [];
        const obj = LocalService.parseJson(fav);
        return obj;
    },
    getHistoricFav: (label) => {
        const obj = LocalService.getAllHistoricFavs();
        if (!obj) return;
        return obj[label];
    },
    setHistoricFav: (label, value) => {
        let obj = LocalService.getAllHistoricFavs();
        if (!obj || obj.length === 0)
            obj = {};
        obj[label] = value;
        localStorage.setItem(LocalService.HISTORIC_FAV_KEY, JSON.stringify(obj));
    },
    removeHistoricFav: (label) => {
        const obj = LocalService.getAllHistoricFavs();
        if (!obj)
            return;

        delete obj[label];

        if (Object.keys(obj).length == 0)
            localStorage.removeItem(LocalService.HISTORIC_FAV_KEY);
        else {
            localStorage.setItem(LocalService.HISTORIC_FAV_KEY, JSON.stringify(obj));
        }
    },
    // getAllStationFavs: () => {
    //     const fav = localStorage.getItem(LocalService.STATION_FAV_KEY);
    //     const obj = LocalService.parseJson(fav);
    //     return obj;
    // },
    // getStationFav: (label) => {
    //     const obj = LocalService.getAllStationFavs();
    //     if (!obj) return;
    //     return obj[label];
    // },
    // setStationFav: (label, value) => {
    //     let obj = LocalService.getAllStationFavs();
    //     if (!obj)
    //         obj = {};
    //     obj[label] = value;
    //     localStorage.setItem(LocalService.STATION_FAV_KEY, JSON.stringify(obj));
    // },
    // removeStationFav: (label) => {
    //     const obj = LocalService.getAllStationFavs();
    //     if (!obj)
    //         return;

    //     delete obj[label];

    //     if (Object.keys(obj).length == 0)
    //         localStorage.removeItem(LocalService.STATION_FAV_KEY);
    //     else {
    //         localStorage.setItem(LocalService.STATION_FAV_KEY, JSON.stringify(obj));
    //     }
    // },
    // getAllTimeseriesFavs: () => {
    //     const fav = localStorage.getItem(LocalService.TIMESERIES_FAV_KEY);
    //     const obj = LocalService.parseJson(fav);
    //     return obj;
    // },
    // getTimeseriesFav: (label) => {
    //     const obj = LocalService.getAllTimeseriesFavs();
    //     if (!obj) return;
    //     return obj[label];
    // },
    // setTimeseriesFav: (label, value) => {
    //     let obj = LocalService.getAllTimeseriesFavs();
    //     if (!obj)
    //         obj = {};
    //     obj[label] = value;
    //     localStorage.setItem(LocalService.TIMESERIES_FAV_KEY, JSON.stringify(obj));
    // },
    // removeTimeseriesFav: (label) => {
    //     const obj = LocalService.getAllTimeseriesFavs();
    //     if (!obj)
    //         return;

    //     delete obj[label];

    //     if (Object.keys(obj).length == 0)
    //         localStorage.removeItem(LocalService.TIMESERIES_FAV_KEY);
    //     else {
    //         localStorage.setItem(LocalService.TIMESERIES_FAV_KEY, JSON.stringify(obj));
    //     }
    // },

    // getAllLatestdataFavs: () => {
    //     const fav = localStorage.getItem(LocalService.LATESTDATA_FAV_KEY);
    //     const obj = LocalService.parseJson(fav);
    //     return obj;
    // },
    // getLatestdataFav: (label) => {
    //     const obj = LocalService.getAllLatestdataFavs();
    //     if (!obj) return;
    //     return obj[label];
    // },
    // setLatestdataFav: (label, value) => {
    //     let obj = LocalService.getAllLatestdataFavs();
    //     if (!obj)
    //         obj = {};
    //     obj[label] = value;
    //     localStorage.setItem(LocalService.LATESTDATA_FAV_KEY, JSON.stringify(obj));
    // },
    // removeLatestdataFav: (label) => {
    //     const obj = LocalService.getAllLatestdataFavs();
    //     if (!obj)
    //         return;

    //     delete obj[label];

    //     if (Object.keys(obj).length == 0)
    //         localStorage.removeItem(LocalService.LATESTDATA_FAV_KEY);
    //     else {
    //         localStorage.setItem(LocalService.LATESTDATA_FAV_KEY, JSON.stringify(obj));
    //     }
    // },

    getAllPinnedFavs: () => {
        var self = this;
        let fav = localStorage.getItem(LocalService.PIN_FAV_KEY);
        if (!fav) return [];
        let favs = LocalService.parseJson(fav);

        let allhistfavs = LocalService.getAllHistoricFavs();

        favs.forEach(f => {
            if (!allhistfavs.hasOwnProperty(f)) {
                //fav is deleted remove from pinned
                var newfavs = favs.filter(function (value, idx, array) {
                    return value !== f;
                });
                localStorage.setItem(LocalService.PIN_FAV_KEY, JSON.stringify(newfavs));
            }
        });

        fav = localStorage.getItem(LocalService.PIN_FAV_KEY);
        favs = LocalService.parseJson(fav);

        return favs;
    },
    pinFav: (label, value) => {
        let favs = LocalService.getAllPinnedFavs();
        if (!Array.isArray(favs))
            favs = [];

        if (favs.indexOf(label) > -1) {
            var newfavs = favs.filter(function(value, idx, array) {
                return value !== label;
            });
            localStorage.setItem(LocalService.PIN_FAV_KEY, JSON.stringify(newfavs));
        } else {
            favs.push(label);
            localStorage.setItem(LocalService.PIN_FAV_KEY, JSON.stringify(favs));
        }

    },
    setFavDate: (selection) => {
        localStorage.setItem(LocalService.FAV_DATE, selection);
    },
    getFavDate: () => {
        const favdate = localStorage.getItem(LocalService.FAV_DATE);
        return parseInt(favdate);
    },
    getFavSettings: () => {
        const favsettings = LocalService.parseJson(localStorage.getItem(LocalService.FAV_SETTINGS));
        if (typeof (favsettings) == "undefined") return [];
        if (!Array.isArray(favsettings)) return [];
        return favsettings;
    },
    setFavSettings: (selections) => {
        localStorage.setItem(LocalService.FAV_SETTINGS, JSON.stringify(selections));
    },
    parseJson: (str) => {
        try {
            return JSON.parse(str);
        } catch (e) {
            return;
        }
    }
};

export default LocalService;
